module.exports = __webpack_public_path__ + "img/keino.3147254d.jpg";